//constants.js
export const CHANGE_BANNER = 'recommend/CHANGE_BANNER';

export const CHANGE_RECOMMEND_LIST = 'recommend/RECOMMEND_LIST';

export const CHANGE_ENTER_LOADING = 'recommend/CHANGE_ENTER_LOADING';
